import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { EventsParam } from './events';
import { Trend } from '../interfaces/trends';

function trendQueryBuilder(params: EventsParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.start_date) {
		queryParams.append('start_date', params.start_date);
	}
	if (params.end_date) {
		queryParams.append('end_date', params.end_date);
	}
	if (params.fk_event_types && params.fk_event_types.length > 0) {
		for (const fkEventType of params.fk_event_types) {
			queryParams.append('fk_event_type', fkEventType);
		}
	}
	if (params.fk_devices && params.fk_devices.length > 0) {
		for (const fkDevice of params.fk_devices) {
			queryParams.append('fk_device', fkDevice);
		}
	}
	return queryParams;
}

async function getTrends(params: EventsParam): Promise<Trend[]> {
	const queryParams = trendQueryBuilder(params);
	try {
		const response = await axios.get<Envelope<Trend[]>>(`trends`, { params: queryParams });
		return response.data.data; //.svg files
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const trends = {
	getTrends,
};
